import Vue from "vue";
import Router from "vue-router";

import store from './store';

// Anonymous pages

import Login from 'src/pages/anonymous/LoginPage.vue';
import ForgotPassword from 'src/pages/anonymous/ForgotPasswordPage.vue';
import ResetPassword from 'src/pages/anonymous/ResetPasswordPage.vue';
import AnonymousNavbar from 'src/pages/anonymous/layout/Navbar.vue';

// Pastlogin pages
import LandingPage from 'src/pages/authenticated/LandingPage.vue';
import PanelsPage from 'src/pages/authenticated/PanelsPage.vue';
import PanelDetailsPage from 'src/pages/authenticated/PanelDetailsPage.vue';
import AttendeesPage from 'src/pages/authenticated/AttendeesPage.vue';
import AttendeeDetailsPage from 'src/pages/authenticated/AttendeeDetailsPage.vue';
import CulturalEventsPage from 'src/pages/authenticated/CulturalEventsPage.vue';
import PartnersPage from 'src/pages/authenticated/PartnersPage.vue';
import PartnerDetailsPage from 'src/pages/authenticated/PartnerDetailsPage.vue';

import MapPage from "src/pages/authenticated/MapPage.vue";
import BuildingsPage from "src/pages/authenticated/BuildingsPage.vue";
//import BuildingDetailsPage from "src/pages/authenticated/BuildingDetailsPage.vue";

import PartyEventsPage from 'src/pages/authenticated/PartyEventsPage.vue';
import TransportFormPage from 'src/pages/authenticated/TransportFormPage.vue';

import ProfilePage from 'src/pages/authenticated/ProfilePage.vue';
import NotificationsPage from 'src/pages/authenticated/NotificationsPage.vue';
import InvitationsPage from 'src/pages/authenticated/InvitationsPage.vue';
import InformationPage from 'src/pages/authenticated/InformationPage.vue';
import ChatPage from 'src/pages/authenticated/ChatPage.vue';
import MainNavbar from 'src/pages/authenticated/layout/Navbar.vue';
import MainFooter from 'src/pages/authenticated/layout/Footer.vue';
import Terms from 'src/pages/authenticated/Terms.vue';
import Privacy from "src/pages/authenticated/Privacy.vue";

Vue.use(Router);

let anonymousRoutes = [{
    path: "/login",
    name: "login",
    components: { default: Login, header: AnonymousNavbar },
    props: { header: { colorOnScroll: 400, navbarTransparent: true } }
},
{
    path: "/forgotpassword",
    name: "forgotpassword",
    components: { default: ForgotPassword, header: AnonymousNavbar },
    props: { header: { colorOnScroll: 400, navbarTransparent: true } }
},
{
    path: "/resetpassword",
    name: "resetpassword",
    components: { default: ResetPassword, header: AnonymousNavbar },
    props: {
        default: route => ({
            username: route.query.username,
            token: route.query.token
        }),
        header: { colorOnScroll: 400, navbarTransparent: true }
    }
}
];

let mainRoutes = [
    {
        path: '/',
        name: 'main',
        components: { default: LandingPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 400, navbarTransparent: true } }
    },
];

let postLoginRoutes = [
    {
        path: '/panels',
        name: 'panels',
        components: { default: PanelsPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/panels/details/:id',
        name: 'panelDetails',
        components: { default: PanelDetailsPage, header: MainNavbar, footer: MainFooter },
        props: {
            default: route => ({
                id: route.params.id,
            }),
            header: { colorOnScroll: 450, navbarTransparent: true }
        }
    },
    {
        path: '/attendees',
        name: 'attendees',
        components: { default: AttendeesPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/attendees/details/:id',
        name: 'attendeeDetails',
        components: { default: AttendeeDetailsPage, header: MainNavbar, footer: MainFooter },
        props: {
            default: route => ({
                id: route.params.id,
            }),
            header: { colorOnScroll: 450, navbarTransparent: true }
        }
    },
    {
        path: '/partners',
        name: 'partners',
        components: { default: PartnersPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/partners/details/:id',
        name: 'partnerDetails',
        components: { default: PartnerDetailsPage, header: MainNavbar, footer: MainFooter },
        props: {
            default: route => ({
                id: route.params.id,
            }),
            header: { colorOnScroll: 450, navbarTransparent: true }
        }
    },
    {
        path: '/map',
        name: 'map',
        components: { default: MapPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/buildings',
        name: 'buildings',
        components: { default: BuildingsPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/cultural-events',
        name: 'cultural-events',
        components: { default: CulturalEventsPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/profile',
        name: 'profile',
        components: { default: ProfilePage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/notifications',
        name: 'notifications',
        components: { default: NotificationsPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/invitations',
        name: 'invitations',
        components: { default: InvitationsPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/information',
        name: 'information',
        components: { default: InformationPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/chat',
        name: 'chat',
        components: { default: ChatPage, header: MainNavbar },
        props: { header: { colorOnScroll: 0, navbarTransparent: false } }
    },
    {
        path: '/recreational-events',
        name: 'party-events',
        components: { default: PartyEventsPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/transport',
        name: 'transport',
        components: { default: TransportFormPage, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
    {
        path: '/terms',
        name: 'terms',
        components: { default: Terms, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
        {
        path: '/privacy',
        name: 'privacy',
        components: { default: Privacy, header: MainNavbar, footer: MainFooter },
        props: { header: { colorOnScroll: 450, navbarTransparent: true } }
    },
];

let routes = [
    ...anonymousRoutes,
    ...mainRoutes,
    ...postLoginRoutes,
    { path: "*", redirectToName: "main" }
];

let router = new Router({
    routes,
    mode: "history",
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
});


router.beforeEach(async (to, from, next) => {
    // Redirect user to login page unless he's past that part already

    if (store.getters['user/profile']) {
        await store.dispatch("user/refreshProfile");
    }

    if (store.getters['user/isLoggedIn']) {
        await store.dispatch("notifications/refresh");
    }

    if (!store.getters['user/profile'] && !anonymousRoutes.filter(r => to.name == r.name).length) {
        return next({
            name: 'login'
        });
    }

    // Redirect user to main page if he's logged or skipped
    if (store.getters['user/profile'] && anonymousRoutes.filter(r => to.name == r.name).length) {
        return next({
            name: 'main'
        });
    }

    // Redirect user to main page if he's unauthorized to access certain route
    // if (store.getters['user/profile'] && anonymousRoutes.filter(r => to.name == r.name).length) {
    //     return next({
    //         name: 'main'
    //     });
    // }

    next();
});



export default router;